module.exports = __webpack_public_path__ + "static/img/iMES-icon.041cfdea.png";